export enum ModelPortfolios {
    checkpoint_trader = 1,
    deep_market_trader = 2,
    monthly_trend_trader = 3,
    profit_skimmer = 4,
    sector_focus = 5,
    transformity_investor = 6,
    transformity_wealth = 7,
    mega_trend_profit_club = 8,
    small_cap_cash_cows = 9
}
